import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { HashRouter, Switch } from "react-router-dom";
import * as serviceWorker from "./serviceWorker";

import AppContextProvider from "./Context/ContextProvider";

//PWA
import { defineCustomElements } from "@ionic/pwa-elements/loader";

ReactDOM.render(
  <HashRouter>
    <Switch>
      <React.Fragment>
        {" "}
        <div className="App-header">
          <AppContextProvider>
            <App />
          </AppContextProvider>
        </div>{" "}
      </React.Fragment>
    </Switch>
  </HashRouter>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// PWA
defineCustomElements(window);
